import PageContainer from '@/common/components/PageContainer'
import CreateReturnLossListing from '@/modules/promotion/components/CreateReturnLoss/components/CreateReturnLossListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'

function CreateReturnLossPage() {
	return (
		<PageContainer>
			<CreateReturnLossListing />
		</PageContainer>
	)
}

const GuardedCreateReturnLossPage = withUserPermission(CreateReturnLossPage, {
	permissionType: PermissionType.Write,
	permissionKey: [PermissionKeys.MANAGE_RETURN_LOSS],
})

export default GuardedCreateReturnLossPage
